import { render, staticRenderFns } from "./filters-item.vue?vue&type=template&id=02959fa8&"
import script from "./filters-item.vue?vue&type=script&lang=js&"
export * from "./filters-item.vue?vue&type=script&lang=js&"
import style0 from "./filters-item.vue?vue&type=style&index=0&id=02959fa8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports